export const GET_LIST_CATALOG_MI_LOADING = 'catalogos/GET_CATALOG_MI_LOADING';
export const GET_LIST_CATALOG_MI_SUCCESS = 'catalogos/GET_CATALOG_MI_SUCCESS';
export const GET_LIST_CATALOG_MI_FAILURE = 'catalogos/GET_CATALOG_MI_FAILURE';

export const UPDATE_CATALOG_MI_LOADING = 'catalogos/UPDATE_CATALOG_MI_LOADING';
export const UPDATE_CATALOG_MI_SUCCESS = 'catalogos/UPDATE_CATALOG_MI_SUCCESS';
export const UPDATE_CATALOG_MI_FAILURE = 'catalogos/UPDATE_CATALOG_MI_FAILURE';
